import { Table } from 'components/lib';
import React, { useState, useEffect } from 'react';
import CustomLoader from 'components/CustomLoader';
import { EndorsementsTable } from '../components/EndorsementsTable';
import { USE_TEXT_INPUT_CARRIERS } from 'helpers/constants';
import styles from '../styles.module.scss';

export function RemoveVehicleOrTrailer({
  vehicles_and_trailers,
  setVehicles_and_trailers,
  endorsements,
  changes,
  loading,
  selected,
  carrier,
  setEndorsements,
  setStage,
  submit,
  submitting,
  resetModal
}) {
  const [removedVehiclesAndTrailers, setRemovedVehiclesAndTrailers] = useState([]);
  const [displayVehicles, setDisplayVehicles] = useState([]);
  const [textInput, setTextInput] = useState('');

  const useTextInput = !carrier || USE_TEXT_INPUT_CARRIERS.includes(carrier);

  useEffect(() => {
    if (!useTextInput) setDisplayVehicles([...vehicles_and_trailers]);
  }, [vehicles_and_trailers, useTextInput]);

  const handleRemove = (item) => {
    const { actions, ...cleanItem } = item;

    setRemovedVehiclesAndTrailers(prev => [...prev, cleanItem]);

    setDisplayVehicles(displayVehicles.filter(vehicle =>
      vehicle.id !== item.id
    ));
  };

  const parseTextToValue = () => {
    const lines = (textInput || '')
      .split(/\n/)
      .map(l => l.trim())
      .filter(Boolean);
    return lines.map(line => ({ description: line }));
  };

  const textValue = parseTextToValue();
  const hasValidTextInput = textValue.length > 0;

  if (useTextInput) {
    return (
      <div className={styles.insideWrapper}>
        <div className={styles.title}>
          Remove a Vehicle or Trailer
        </div>
        <div className={styles.line} />
        <div className={styles.tableWrapper} style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 8 }}>
            Enter one vehicle or trailer to remove per line
          </label>
          <textarea
            value={textInput}
            onChange={(e) => setTextInput(e.target.value)}
            placeholder={'e.g. 2020 Ford F-150\n2019 Trailer VIN 123'}
            rows={6}
            style={{
              width: '100%',
              padding: 8,
              boxSizing: 'border-box',
              fontFamily: 'inherit',
            }}
          />
        </div>

        {endorsements.length > 0 && (
          <EndorsementsTable changes={changes} loading={loading} />
        )}

        <div
          className={styles.footer}
          style={{ justifyContent: 'space-between' }}
        >
          <div className={styles.buttons}>
            <button className={styles.cancel} onClick={resetModal}>
              Cancel
            </button>
          </div>
          <div className={styles.buttons}>
            <button
              className={styles.save}
              style={{ marginRight: 10, marginLeft: 10, width: '240px' }}
              onClick={() => {
                if (hasValidTextInput) {
                  setEndorsements((prev) => [
                    ...prev,
                    { type: 'remove_vehicles_or_trailers', value: textValue },
                  ]);
                  setTextInput('');
                  setStage('select_endorsement_type');
                } else {
                  setStage('select_endorsement_type');
                }
              }}
            >
              Add Another Change
            </button>
            <button
              className={styles.save}
              style={{ width: '330px' }}
              onClick={() => {
                if (hasValidTextInput) {
                  submit([
                    ...endorsements,
                    { type: 'remove_vehicles_or_trailers', value: textValue },
                  ]);
                }
              }}
              disabled={!hasValidTextInput}
            >
              {submitting ? (
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <CustomLoader />
                </div>
              ) : (
                'Finish and Submit Endorsement'
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.insideWrapper}>
      <div className={styles.title}>
        Remove a Vehicle or Trailer
      </div>
      <div className={styles.line} />
      <div className={styles.tableWrapper}>
        <Table
          data={displayVehicles}
          loading={loading}
          hide={['id']}
          columns={['Year', 'Make', 'Model', 'VIN', 'Value']}
          actions={{
            custom: [
              {
                icon: 'trash',
                action: handleRemove,
                color: '#637381',
                tooltip: 'Remove this Vehicle/Trailer',
              },
            ],
          }}
        />
      </div>

      {endorsements.length > 0 && (
        <EndorsementsTable changes={changes} loading={loading} />
      )}

      <div
        className={styles.footer}
        style={{
          justifyContent: 'space-between',
        }}
      >
        <div className={styles.buttons}>
          <button
            className={styles.cancel}
            onClick={resetModal}
          >
            Cancel
          </button>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.save}
            style={{
              marginRight: 10,
              marginLeft: 10,
              width: '240px',
            }}
            onClick={async () => {
              if (removedVehiclesAndTrailers.length > 0) {
                setEndorsements((prev) => [
                  ...prev,
                  {
                    type: 'remove_vehicles_or_trailers',
                    value: removedVehiclesAndTrailers,
                  },
                ]);

                setVehicles_and_trailers(displayVehicles);
                setStage('select_endorsement_type');
              } else {
                setStage('select_endorsement_type');
              }
            }}
          >
            Add Another Change
          </button>
          <button
            className={styles.save}
            style={{ width: '330px' }}
            onClick={async () => {
              if (removedVehiclesAndTrailers.length > 0) {
                setVehicles_and_trailers(displayVehicles);

                submit([
                  ...endorsements,
                  {
                    type: 'remove_vehicles_or_trailers',
                    value: removedVehiclesAndTrailers,
                  },
                ]);
              }
            }}
          >
            {submitting ? (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CustomLoader />
              </div>
            ) : (
              'Finish and Submit Endorsement'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
